import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { onMounted, watch, ref, computed } from 'vue';
import { DropdownMenuRoot, DropdownMenuTrigger, DropdownMenuPortal, DropdownMenuContent, DropdownMenuItem, } from 'reka-ui';
import EnIcon from 'Components/icons/EnIcon.vue';
import { EnPowerIdType } from 'Components/types/EnPowerIdType.js';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EnPowerAccountSwitch',
    props: /*@__PURE__*/ _mergeModels({
        enPowerAccounts: { type: Array, required: true },
        isExpanded: { type: Boolean, required: false }
    }, {
        "modelValue": { type: [Object, String, null] },
        "modelModifiers": {},
    }),
    emits: /*@__PURE__*/ _mergeModels(["updateEnPowerId", "update:hasEnPowerAccount"], ["update:modelValue"]),
    setup(__props, { expose: __expose, emit: __emit }) {
        __expose();
        const props = __props;
        const currentEnpowerAccount = _useModel(__props, 'modelValue');
        const emit = __emit;
        const powerMenuOpen = ref(false);
        function emitEnPowerAccountIdSet(newVal) {
            const defaultEnPowerId = EnPowerIdType.defaultEnPowerId;
            let newEnPowerId = newVal?.Id ?? newVal;
            if (newVal === EnPowerIdType.noEnpowerId) {
                newEnPowerId = defaultEnPowerId;
            }
            emit('updateEnPowerId', defaultEnPowerId, newEnPowerId);
            emit('update:hasEnPowerAccount', newEnPowerId !== EnPowerIdType.noEnpowerId);
            localStorage.enPowerAccountId = newEnPowerId;
        }
        watch(currentEnpowerAccount, (newVal) => {
            emitEnPowerAccountIdSet(newVal);
        });
        const currentName = computed(() => {
            const acc = currentEnpowerAccount.value;
            if (acc && typeof acc === 'object')
                return acc.Name;
            const found = props.enPowerAccounts.find((a) => a.Id === acc);
            return found?.Name ?? '';
        });
        function selectAccount(account) {
            currentEnpowerAccount.value = account;
            powerMenuOpen.value = false;
        }
        onMounted(() => {
            if (Object.prototype.hasOwnProperty.call(localStorage, 'enPowerAccountId')
                && props.enPowerAccounts.some((a) => a.Id === localStorage.enPowerAccountId)) {
                currentEnpowerAccount.value = props.enPowerAccounts.find((a) => a.Id === localStorage.enPowerAccountId) ?? null;
                emitEnPowerAccountIdSet(currentEnpowerAccount.value);
            }
            else if (props.enPowerAccounts.length >= 1) {
                const enlocEnergyAccount = props.enPowerAccounts.find((account) => account.Id === 'enloc-energy');
                currentEnpowerAccount.value = enlocEnergyAccount ?? props.enPowerAccounts[0];
                emitEnPowerAccountIdSet(currentEnpowerAccount.value);
            }
        });
        const __returned__ = { props, currentEnpowerAccount, emit, powerMenuOpen, emitEnPowerAccountIdSet, currentName, selectAccount, get DropdownMenuRoot() { return DropdownMenuRoot; }, get DropdownMenuTrigger() { return DropdownMenuTrigger; }, get DropdownMenuPortal() { return DropdownMenuPortal; }, get DropdownMenuContent() { return DropdownMenuContent; }, get DropdownMenuItem() { return DropdownMenuItem; }, EnIcon };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
